import {Link} from '@primer/react'
import type {LinkProps} from '@primer/react'
import {useGetHovercardAttributesForType} from '@github-ui/hovercards/use-get-hovercard-attributes-for-type'
import {repositoryPath} from '@github-ui/paths'
import styles from './RepositoryContext.module.css'

interface RepositoryContextProps {
  owner: string
  name: string
}

export function RepositoryContext(props: RepositoryContextProps) {
  return (
    <div className={styles.RepositoryContext}>
      <RepositoryLink {...props} style={{color: 'var(--fgColor-muted)'}} />
    </div>
  )
}

type RepositoryLinkProps = RepositoryContextProps & LinkProps

export function RepositoryLink({owner, name, ...linkProps}: RepositoryLinkProps) {
  const getHovercardAttributesForType = useGetHovercardAttributesForType()
  return (
    <Link
      href={repositoryPath({owner, repo: name})}
      {...getHovercardAttributesForType('repository', {owner, repo: name})}
      {...linkProps}
    >
      <span>{`${owner}/${name}`}</span>
    </Link>
  )
}
